import { Component, inject, Input } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { EComplaintStatus } from '../../../utils/enums';

@Component({
  selector: 'app-mb-status-tag',
  imports: [],
  templateUrl: './mb-status-tag.component.html',
})
export class MbStatusTagComponent {
  @Input() status: EComplaintStatus = EComplaintStatus.PENDING_APPROVAL;
  @Input() size: 'small' | 'medium' = 'medium';
  private t = inject(TranslocoService);

  getStyles() {
    let baseClass = 'px-4 ';
    if (this.size === 'small') {
      baseClass += 'h-6 text-[12px] font-semibold';
    } else if (this.size === 'medium') {
      baseClass += 'font-bold tracking-tight text-md min-w-36 max-w-40 h-10';
    } else {
      baseClass += 'font-black tracking-tighter text-lg min-w-48 max-w-60 h-12';
    }

    switch (this.status) {
      case EComplaintStatus.ONGOING:
        return baseClass + ' text-mbaza-label-ongoing bg-mbaza-ongoing max-w-30';
      case EComplaintStatus.PENDING_APPROVAL:
        return baseClass + ' border border-mbaza-gray-dark max-w-40';
      case EComplaintStatus.RE_OPENED:
        return baseClass + ' bg-mbaza-red text-mbaza-text-red max-w-30';
      case EComplaintStatus.CLOSED:
        return baseClass + ' bg-mbaza-closed text-mbaza-label-closed max-w-30';
      case EComplaintStatus.RESOLVED:
        return baseClass + ' bg-mbaza-green text-mbaza-text-green max-w-30';
      case EComplaintStatus.REJECTED:
        return baseClass + ' bg-mbaza-red text-mbaza-text-red max-w-30';
      default:
        return '';
    }
  }

  getStatusText() {
    switch (this.status) {
      case EComplaintStatus.ONGOING:
        return this.t.translate('statusOngoing');
      case EComplaintStatus.PENDING_APPROVAL:
        return this.t.translate('statusPending');
      case EComplaintStatus.REJECTED:
        return this.t.translate('statusRejected');
      case EComplaintStatus.RE_OPENED:
        return this.t.translate('statusReOpened');
      case EComplaintStatus.CLOSED:
        return this.t.translate('statusClosed');
      case EComplaintStatus.RESOLVED:
        return this.t.translate('statusDone');
      default:
        return '';
    }
  }
}
